import { render, staticRenderFns } from "./DzdMx.vue?vue&type=template&id=080a5c47&scoped=true"
import script from "./DzdMx.vue?vue&type=script&lang=js"
export * from "./DzdMx.vue?vue&type=script&lang=js"
import style0 from "./DzdMx.vue?vue&type=style&index=0&id=080a5c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a5c47",
  null
  
)

export default component.exports